import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage: React.FC = () => (
  <div className="svcpage">
    <div className="svcpage-hero" style={{ padding: '120px 0' }}>
      <div className="orb orb-1" style={{ opacity: 0.5 }} />
      <div className="hero-grid" />
      <div className="container">
        <span className="section-label" style={{ justifyContent: 'center', display: 'flex', marginBottom: 16 }}>
          404
        </span>
        <h1>
          This page<br />
          <span className="gt">does not exist</span>
        </h1>
        <p>The link may be old or mistyped. Here are a few places to go instead.</p>
        <div className="hire-hero-ctas">
          <Link to="/" className="btn btn-primary">Back to Home</Link>
          <Link to="/services" className="btn btn-ghost">Services</Link>
          <Link to="/contact" className="btn btn-ghost">Get In Touch</Link>
        </div>
      </div>
    </div>
  </div>
);

export default NotFoundPage;
